(function() {
  window.ExtraRemoval = (function() {
    function ExtraRemoval() {}

    ExtraRemoval.setup = function() {
      return ExtraRemoval.decorate();
    };

    ExtraRemoval.decorate = function() {
      $(".js-extra-removal").find(".js-zoom").zoom();
      $(document).on('click', '.js-extra-removal-action', function(e) {
        var $link = $(this);
        e.preventDefault();
        var action = $link.data('action');
        return $.ajax({
          method: "POST",
          url: $link.attr('href'),
          dataType: "json",
          data: {
            status: action
          },
          success: function(data) {
            console.log(data);
            return $(".extra-row[data-extra=" + data.id + "]")
              .removeClass("protected")
              .removeClass("removed")
              .removeClass("pending")
              .addClass(data.status);
          }
        });
      });

    };

    return ExtraRemoval;

  })();

}).call(this);